import {get} from 'lodash';

export default (state: any, {hasError}: any) => ({
  ...state,
  supportedLanguages: {
    ...get(state, 'supportedLanguages', {}),
    hasError,
  },
});
